module.exports = __webpack_public_path__ + "img/3.c3843d04.svg";